<template>
    <v-container fluid class="pa-0">
    <!-- Formulaire -->
    <v-card fluid class="ma-2 pa-3 elevation-0 rounded-xxl micorise-v-card">
        <v-card-title >
            Champ du Quiz
            <v-spacer></v-spacer>
            <v-chip outlined color="secondary">
                    <v-icon left>mdi-information-outline</v-icon>Modification: {{ $date(item.updatedAt).format('DD MMMM YYYY') }}
            </v-chip>
        </v-card-title>
        <v-layout row wrap class="layout-flex-2" style="">
            <v-flex xs8>
                <v-text-field outlined dense class="rounded-lg" label="Titre" v-model="item.qiz_name" ></v-text-field>
            </v-flex>
            <!-- right side -->
            <v-flex xs4></v-flex>
            <v-flex xs8>
                <v-textarea outlined dense rows="2" class="rounded-lg" label="Question" v-model="item.qiz_description"></v-textarea>
            </v-flex>
            <!-- right side -->
            <v-flex xs4>

            </v-flex>
            <v-flex xs8>
                <v-select :items="typeListByGroup['QTY']" item-text="typ_description" item-value="typ_id" outlined dense
                    v-model="item.qiz_typ_id_field" label="Type de champ" >
                </v-select>
            </v-flex>
            <!-- right side -->
            <v-flex xs4></v-flex>
            <v-flex xs8>
                
            </v-flex>
            <!-- right side -->
            <v-flex xs4></v-flex>
            <v-flex xs4>
                <v-radio-group v-model="item.qiz_visibility" mandatory>
                    <v-radio label="Actif" :value="1" ></v-radio>
                    <v-radio label="Innactif" :value="0" ></v-radio>
                </v-radio-group>
            </v-flex>
            <v-flex xs4>
                
            </v-flex>
            <v-flex xs4>
                
            </v-flex>
        </v-layout>
        <v-card-actions>
            <v-btn class="rounded-xl" large color="red" v-if="item.uid" @click="deleteItem(item)"><v-icon title="Supprimer">mdi-delete</v-icon></v-btn>
            <v-spacer></v-spacer>
            <v-btn class="rounded-xl" large color="success" :loading="loading.fetchData" @click.native="saveItem()" :disabled="loading.fetchData">Enregistrer</v-btn>
            <v-btn class="rounded-xl" large color="primmary" :to="{ name: 'quizzes-list' }">Retour</v-btn>
        </v-card-actions>
    </v-card>
    <v-data-table v-bind:headers="headers" :items="itemList" item-key="id" :search="search"
        items-per-page-text="Lignes par page" hide-default-header
        :items-per-page-options="pagination.rowsPerItem">
        <template v-slot:top>
            <v-row class="rounded-lg ma-0 pa-0">
                <v-col cols="6" md="6" class="pa-1"></v-col>
                <v-col cols="6" md="6" class="pa-1"></v-col>
            </v-row>
        </template>
        <template v-slot:[`item.qiz_name`]="{ item }"><v-chip class="ma-2" color="secondary">{{ item.qiz_name }}</v-chip><v-icon>mdi-arrow-right</v-icon></template>
        <template v-slot:[`item.qiz_id`]="{ item }">
            <v-btn rounded :to="{ name: 'quizzes-edit', params: { qiz_id: item.qiz_id } }" color="orange" elevation="0" dark>
                <v-icon left  >{{item.qiz_id}} mdi-pencil</v-icon> Fiche
            </v-btn>
        </template>
        <template v-slot:no-data>
        <v-alert :value="( !itemList.lenght )" color="error" icon="mdi-alert">
            Aucun evenement
        </v-alert>
        </template>
    </v-data-table>
    </v-container>
</template>
    
<script>
//import AutocompleteMulti from '@/components/ui/AutocompleteMulti'
import { mapState, mapWritableState, mapActions } from 'pinia'
import { useQuizStore } from '@/stores/quiz'

import { useTypeStore } from '@/stores/type'

export default {
    name: 'quizzes-edit',
    components: {  }, //AutocompleteMulti
    computed: {
        ...mapWritableState(useQuizStore, {itemList: 'itemList', item: 'item' }),
        ...mapState(useTypeStore, {typeListByGroup: 'itemListByGroup', typeListById: 'itemListById' }),
    },
    data: function () {
        return {
            loading: { fetchData: true },
            listEntities: [], listAgencies: [],
            search: null, searchAddress: null, searchBoxClosed: true, addressTab: [], timeOutHandle: 'off',
            pagination: { totalItems: 0, rowsPerPage: 10, rowsPerItem: [15,25,35,{text:'Tout',value:-1}] },
            headers: [
                { text: 'Nom',    value: 'qiz_name', align: 'left'},
                { text: 'Type',   value: 'qiz_typ_id', align: 'left'},
                { text: 'Action', value: 'qiz_id', align: 'right'},
            ],
        }
    },
    async mounted () {
        await this.fetchItem( this.$route.params.qiz_id, '?qiz_sta_id=GEN01' )

        await this.fetchItems('?per_page=false&qiz_id_parent=' + this.$route.params.qiz_id)
        this.loading.fetchData = false
    },
    methods: {
        ...mapActions(useQuizStore, {fetchItems: 'fetchItems', fetchItem: 'fetchItem', updateItem: 'updateItem', storeItem: 'storeItem'}),
        async saveItem () {
            // Enregistrement du formulaire
            this.loading.fetchData = true
            if( parseInt( this.$route.params.qiz_id ) > 0 ){
                this.updateItem()
            } else {
                this.storeItem()
            }
            this.$router.push({ path: '/quizzes' })
        },
    }
}
</script>